import { useEffect, useState } from 'react';
import { fundingCurrencyContext } from './currency-context.js';
/** Expiry invalidates the UI even when the rate query has not rendered a new result yet. */
export function useFundingCurrency(currency, snapshot) {
    const [, tick] = useState(0);
    const context = fundingCurrencyContext(currency, snapshot, Date.now());
    const expiresAt = context.fx?.expiresAt;
    useEffect(() => {
        if (!expiresAt)
            return;
        const expiry = Date.parse(expiresAt);
        if (!Number.isFinite(expiry) || expiry <= Date.now())
            return;
        const timer = setTimeout(() => tick((revision) => revision + 1), Math.min(expiry - Date.now(), 2147483647));
        return () => clearTimeout(timer);
    }, [expiresAt]);
    return context;
}
